import { onScopeDispose, ref, watch } from 'vue';
import { useEventListener } from '@vueuse/core';
import { useAccount } from './useAccount';
import { useEmitter } from './emitter';
import { BUS_EVENTS } from 'shared/constants/busEvents';

// Refresh through the authenticated API; websocket events carry only IDs.
export const useKanbanRefresh = (refresh, canRefresh = () => true) => {
  const { accountId } = useAccount();
  const pending = ref(false);
  let running = false;
  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      if (!pending.value || running || !canRefresh() || document.hidden) return;
      pending.value = false;
      running = true;
      try {
        await refresh();
      } finally {
        running = false;
        if (pending.value) schedule();
      }
    }, 250);
  };
  const request = () => {
    pending.value = true;
    schedule();
  };
  useEmitter(BUS_EVENTS.KANBAN_CHANGED, data => {
    if (Number(data.account_id) === Number(accountId.value)) request();
  });
  useEmitter(BUS_EVENTS.WEBSOCKET_RECONNECT, request);
  useEventListener(window, 'focus', request);
  useEventListener(document, 'visibilitychange', () => {
    if (!document.hidden) request();
  });
  watch(canRefresh, ready => {
    if (ready && pending.value) schedule();
  });
  watch(accountId, () => {
    pending.value = false;
    clearTimeout(timer);
  });
  onScopeDispose(() => {
    pending.value = false;
    clearTimeout(timer);
  });
};
